import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const SummaryStyled = styled.div`
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};
  border-radius: 12px;
  padding: 20px;
  border: solid 1px
    ${(props) => props.theme.atlas.semantic.color.outline.default};
  height: fit-content;
  box-shadow: 0px 0px 1px 0px #00000066;
  box-shadow: 0px 8px 24px -6px #00000029;
`;

export const SummaryTitle = styled.h3`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
  margin: 0;
  margin-bottom: 10px;
`;

export const SummaryStatRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SummaryStat = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  margin: 0;
  margin-bottom: 5px;
`;
